import { render, staticRenderFns } from "./LiveModal.vue?vue&type=template&id=1256bdd7&scoped=true"
import script from "./LiveModal.vue?vue&type=script&lang=js"
export * from "./LiveModal.vue?vue&type=script&lang=js"
import style0 from "./LiveModal.vue?vue&type=style&index=0&id=1256bdd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256bdd7",
  null
  
)

export default component.exports